import Vue from 'vue';
import {parsePhoneNumberFromString} from 'libphonenumber-js';

export type ContactAction = 'call' | 'whatsapp' | 'mail' | 'visit';

/** One contact line (phone, mobile, mail, website …) with its quick actions; `value` is what is dialled/copied */
export interface ContactLine {
    icon: string;
    label: string;
    value: string;
    display?: string;
    note?: string;
    actions: ContactAction[];
}

export function formatPhone(value: string): string {
    const num = value ? parsePhoneNumberFromString(value, 'DE') : undefined;
    return num ? num.formatInternational() : value;
}

export function websiteHref(value: string): string {
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export function initialsOf(name: string): string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return '?';
    }
    return `${parts[0][0]}${parts.length > 1 ? parts[parts.length - 1][0] : ''}`.toUpperCase();
}

/** Copies text and confirms with a snackbar ("Adresse kopieren" / "Kopieren" icon buttons) */
export async function copyWithSnackbar(vm: Vue, text: string, label: string): Promise<void> {
    try {
        await navigator.clipboard.writeText(text);
        vm.$$showSnackbar(`${label} kopiert`, 'success');
    } catch (e) {
        vm.$$showSnackbar('Kopieren nicht möglich', 'error', e);
    }
}
